var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alertText && typeof(_vm.alertText)==='string')?_c('div',{staticClass:"alert-banner"},[_c('p',{staticClass:"alert-banner__content"},[_vm._v("\n    "+_vm._s(_vm.alertText)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }